import React, { useState } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { BiPhone, BiEnvelope } from "react-icons/bi";
import { BsFacebook, BsInstagram, BsLinkedin } from "react-icons/bs";

// Fix for missing marker icons in React-Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you! We’ll get in touch soon.");
    setForm({ name: "", email: "", message: "" });
  };

  const position = [17.369126, 78.539562]; // Hyderabad coordinates

  return (
    <div className="container py-5">
      <h2 className="mb-5 text-center">Contact Us</h2>
      <div className="row g-5">
        {/* Contact Form */}
        <div className="col-lg-6">
          <form onSubmit={handleSubmit} className="row g-3 p-4 bg-light rounded shadow">
            <div className="col-md-6">
              <label className="form-label">Name</label>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                type="text"
                className="form-control"
                required
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">Email</label>
              <input
                name="email"
                value={form.email}
                onChange={handleChange}
                type="email"
                className="form-control"
                required
              />
            </div>
            <div className="col-12">
              <label className="form-label">Message</label>
              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                className="form-control"
                rows="5"
                required
              />
            </div>
            <div className="col-12 d-flex justify-content-end">
              <button type="submit" className="btn btn-primary">Send Message</button>
            </div>
          </form>
        </div>

        {/* Map & Office Info */}
        <div className="col-lg-6">
          <div className="mb-4">
            <h5>Our Location </h5>
           <MapContainer center={position} zoom={15} style={{ height: "400px", borderRadius: "12px" }}>
  {/* Satellite imagery */}
  <TileLayer
    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
  />
  
  {/* Labels overlay */}
  <TileLayer
    url="https://services.arcgisonline.com/ArcGIS/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}"
    opacity={0.7} // semi-transparent overlay
  />
  
  <Marker position={position}>
    <Popup>Orgavitaz HQ, Hyderabad</Popup>
  </Marker>
</MapContainer>

          </div>

          <div className="p-4 bg-light rounded shadow">
            <h5>Office Details</h5>
            <p><BiPhone /> +91-40-24045551</p>
            <p><BiEnvelope /> contactus@orgavitaz.com</p>
            <p>Working Hours: Mon - Sat, 9am - 6pm</p>

            <div className="d-flex gap-3 mt-3">
              <a href="#"><BsFacebook size={24} /></a>
              <a href="#"><BsInstagram size={24} /></a>
              <a href="#"><BsLinkedin size={24} /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
